import { api } from "..";

import { NewUser } from "@/types/ApiResponses/User";

export interface UpdateAgentPayload {
  id: number;
  password?: string;
  image?: string | null;
  balance?: number;
  bettingRulesLocked?: boolean;
}

export async function updateAgent(
  payload: UpdateAgentPayload
): Promise<NewUser> {
  const { id, ...body } = payload;
  const res = await api.client.patch(`/agents-new/${id}`, body);
  return res.data;
}
